import { useCallback, useMemo } from "react";
import {
  Profile,
  setIsAuth as setIsAuthAction,
  setProfile as setProfileAction,
} from "store/authSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  removeLocalStorageAccessToken,
  removeLocalStorageItem,
  removeLocalStorageRefreshToken,
} from "utils/helpers/localStorage";

export const useAuth = () => {
  // const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const getDomain = () => {
    const domainName =
      window.location.hostname.indexOf(".azurewebsites.net") !== -1
        ? window.location.hostname
        : window.location.hostname
            .split(".")
            .reverse()
            .splice(0, 2)
            .reverse()
            .join(".");
    return domainName;
  };

  const setIsAuth = useCallback(
    (isAuth: boolean) => {
      dispatch(setIsAuthAction(isAuth));
    },
    [dispatch]
  );

  const setProfile = useCallback(
    (profile: Profile) => {
      dispatch(setProfileAction(profile));

      const value = btoa(
        JSON.stringify({
          username: profile.email,
        })
      );

      const domainName = getDomain();
      document.cookie =
        "atlantic_sso_user=" +
        value +
        "; expires=Session; path=/; secure; SameSite=Lax; domain=." +
        domainName;

      sessionStorage.setItem("noRedirect", "true");
    },
    [dispatch]
  );

  const logout = useCallback(
    (deleteCookie: boolean = true) => {
      setIsAuth(false);
      removeLocalStorageAccessToken();
      removeLocalStorageRefreshToken();
      removeLocalStorageItem("loginState");
      removeLocalStorageItem("isInMaintenanceOpened");

      if (deleteCookie) {
        const domainName = getDomain();
        document.cookie =
          "atlantic_sso_user=''; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; secure; SameSite=Lax; domain=." +
          domainName;
      }
    },
    [setIsAuth]
  );

  // const getProfile = useCallback(() => {
  //   return dispatch(getProfileAction());
  // }, [dispatch]);

  // const logout = useCallback(() => {
  //   removeAuthTokens();
  //   return dispatch(logoutAction());
  // }, [dispatch]);

  return useMemo(
    () => ({
      isAuth: authState.isAuth,
      setIsAuth,
      setProfile,
      logout,
      ...authState.profile,
    }),
    [authState.isAuth, authState.profile, logout, setIsAuth, setProfile]
  );
};
